<template lang="pug">
  app-plotly(nomeDiv="graficoQuantidadeProcessoMensal", :dados="graficoDados", :layout="layout")
</template>

<script>
import AppPlotly from '../shared/AppPlotly'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosLabels: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      dados: [],
      layout: {
        showlegend: true,
        height: 450,
        legend: {
          orientation: 'v'
        },
        xaxis: {
          title: 'Mês'
        },
        yaxis: {
          title: 'Quantidade de Processos'
        },
        margin: {
          b: 90,
          l: 45,
          t: 55
        }
      },
      colors: ['#0e527e', '#39dac0', '#f94571', '#fdd25e', '#60ce6e', '#6092ce', '#b960ce', '#ce5f73', '#ce7e60', '#FF4D4D', '#99E6E6', '#6666FF'],
      loading: true,
      mes: [],
      meses: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez']
    }
  },

  mounted () {
    this.dados = this.dadosLabels
  },

  computed: {

    baseMonths () {
      this.mes = []; // eslint-disable-line
      this.dados.forEach((element) => {
        const mes = this.meses[element.label - 1] + '/' + element.ano; // eslint-disable-line
        this.mes.push(mes);  // eslint-disable-line
      })
      return this.mes.map((mes, index) => ({
        x: [mes],
        y: [0],
        type: 'bar',
        text: '',
        textposition: 'auto',
        textfont: {
          size: 14
        },
        name: mes,
        periodo: '',
        hoverinfo: 'none',
        marker: { color: [this.colors[index]] }
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dados)) {   // eslint-disable-line
        return []
      }

      let graficoDados = this.baseMonths

      for (let index = 0; index < this.dados.length; index++) {
        graficoDados[Number(this.dados[index].label) - 1] = {
          ...graficoDados[Number(this.dados[index].label) - 1],
          y: [this.dados[index].valor],
          text: this.dados[index].valor,
          periodo: this.dados[index].periodo
        }
      }

      graficoDados = _.orderBy(graficoDados, ['periodo', 'asc']); // eslint-disable-line
      return graficoDados
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/graficos/GraficoQuantidadeProcessoMensal.vue